import React from 'react';
import './styles.css';

export default function LayoutContainer(props) {
  const className = props.className ?? "";
  
  return(
    <div className={className + " layout-container flex-container flex-horizontal"}>
      {props.children}
    </div>
  );
}

export function LeftColumnContainer(props) {
  return(
    <div className="left-column-container flex-width">
      {props.children}
    </div>
  );
}

export function RightColumnContainer(props) {

  return(
    <div className="right-column-container flex-width">
      {props.children}
    </div>
  );
}